import { Link } from 'react-router-dom';
import { Check, Lock, Sparkles } from 'lucide-react';
import { DialogTitle } from '@/components/ui/dialog';

const LO_QUE_SUMA = [
  'Todas las tiendas que Prixia lee, no sólo una',
  'Tu catálogo completo, sin el tope de 100 productos',
  'Cotiza y Comercia, con tu equipo adentro',
  'Estrategias y decisiones sobre tus propios productos',
];

/**
 * Mini Prixia: lo que ve quien está probando cuando entra a algo que no incluye la
 * demo. No es un error ni un permiso: es la invitación a seguir.
 */
/**
 * Con `alSeguir` va adentro de un `Dialog` (Competencia, Ronda V): «Seguir probando» lo
 * cierra y su encabezado es el título del diálogo (no hace falta otro `DialogTitle`).
 */
export function ParteDelPlanCompleto({ alSeguir }: { alSeguir?: () => void } = {}) {
  return (
    <div className={alSeguir ? undefined : 'flex min-h-[60vh] items-center justify-center p-4'}>
      <div className="w-full max-w-md overflow-hidden rounded-2xl border bg-card shadow-sm">
        <div className="bg-degradado-prixia px-6 py-5 text-white">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider opacity-90">
            <Lock className="h-3.5 w-3.5" aria-hidden="true" />
            Plan completo
          </div>
          {alSeguir ? (
            <DialogTitle asChild>
              <h2 className="mt-1 text-2xl font-semibold leading-normal tracking-normal">
                Esto es parte del plan completo
              </h2>
            </DialogTitle>
          ) : (
            <h1 className="mt-1 text-2xl font-semibold">Esto es parte del plan completo</h1>
          )}
        </div>
        <div className="space-y-4 px-6 py-5">
          <p className="text-muted-foreground">
            Tu prueba incluye Compite con la tienda que elegiste. Con el plan completo también
            tienes:
          </p>
          <ul className="space-y-2">
            {LO_QUE_SUMA.map((t) => (
              <li key={t} className="flex items-start gap-2 text-sm">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
                {t}
              </li>
            ))}
          </ul>
          <div className="flex flex-wrap gap-2 pt-1">
            <a
              href="mailto:ventas@prixia.com?subject=Quiero%20el%20plan%20completo%20de%20Prixia"
              className="inline-flex items-center gap-2 rounded-xl bg-degradado-prixia px-4 py-2 text-sm font-semibold text-white"
            >
              <Sparkles className="h-4 w-4" aria-hidden="true" />
              Quiero el plan completo
            </a>
            {alSeguir ? (
              <button
                type="button"
                onClick={alSeguir}
                className="inline-flex items-center rounded-xl border px-4 py-2 text-sm font-medium hover:bg-muted"
              >
                Seguir probando
              </button>
            ) : (
              <Link
                to="/compite/monitoreo"
                className="inline-flex items-center rounded-xl border px-4 py-2 text-sm font-medium hover:bg-muted"
              >
                Seguir probando
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
